<template>
    <div class="col-md-12 mx-auto">
        <div class="card mt-12">
            <div class="card-header bg-primary text-white">
                <page-title :title="($t(titleKey))"></page-title>
            </div>

            <div class="card-header" v-if="showSettingsBtn">
                <i class="fas fa-cogs pointer fa-2x float-right text-success"
                   v-if="showSettingsBtn"
                   @click.stop="changeGridSettings"
                   data-toggle="tooltip"
                   :title="settingsTooltipText"></i>

                <grid-user-settings :schemaModelFields="schemaModelFields" :componentName="componentName"
                                    v-if="showUserSettingsForm" @change="gridSettingsChanged"></grid-user-settings>
            </div>

            <div class="card-body">
                <div class="btn-toolbar justify-content-between mt-0 mb-2" role="toolbar">
                    <div class="form-inline col-6"></div>

                    <div class="input-group">
                        <input v-model="searchQuery"
                               v-on:keyup.enter.stop="massSearch"
                               v-on:keyup.esc.stop="clearFilters"
                               type="text"
                               class="form-control"
                               aria-label="Mass search input"
                               aria-describedby="massSearch"/>
                        <button class="btn btn-secondary" @click.stop="massSearch">
                            <i class="fas fa-search"></i>
                            {{ $t('buttons.search.btnText') }}
                        </button>
                        <button class="btn btn-secondary" @click.stop="clearFilters">
                            <i class="fas fa-times"></i>
                            {{ $t('buttons.clearFilters.btnText') }}
                        </button>
                    </div>
                </div>

                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size="defaultGridRows"
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd"></kendo-datasource>

                <kendo-grid ref="grid"
                            data-source-ref="datasource1"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            v-on:detailinit="detailInit"
                            :data-bound="dataBound">
                    <kendo-grid-column :field="'id'"
                                       :title="$t('registers.theme.gridHeaders.id')"
                                       :expandable="true"
                                       :hidden="true"
                                       :locked="false"
                                       :lockable="true"
                                       :width="100"></kendo-grid-column>
                    <kendo-grid-column :field="'name'"
                                       :title="$t('registers.theme.gridHeaders.thematicArea')"
                                       :width="450"
                                       :locked="false"
                                       :lockable="true"
                                       :hidden="isEnVersion"></kendo-grid-column>
                    <kendo-grid-column :field="'nameEn'"
                                       :title="$t('registers.theme.gridHeaders.thematicArea')"
                                       :width="450"
                                       :locked="false"
                                       :lockable="true"
                                       :hidden="!isEnVersion"></kendo-grid-column>
                    <kendo-grid-column :field="'legalArea'"
                                       :title="$t('registers.theme.gridHeaders.legalArea')"
                                       :width="450"
                                       :locked="false"
                                       :lockable="true"
                                       :hidden="isEnVersion"></kendo-grid-column>
                    <kendo-grid-column :field="'legalAreaEn'"
                                       :title="$t('registers.theme.gridHeaders.legalArea')"
                                       :width="450"
                                       :locked="false"
                                       :lockable="true"
                                       :hidden="!isEnVersion"></kendo-grid-column>
                    <kendo-grid-column :field="'deactivated'"
                                       :title="$t('registers.theme.gridHeaders.deactivated')"
                                       :locked="false"
                                       :lockable="true"
                                       :hidden="true"
                                       :width="150"></kendo-grid-column>
                    <kendo-grid-column :field="'active'"
                                       :template="activeCellTemplate"
                                       :title="$t('registers.theme.gridHeaders.active')"
                                       :locked="false"
                                       :lockable="true"
                                       :width="150"></kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'; // това се изисква за да се вмъкват kendo ui компоненти. Виж метод parentIdDropDownEditor
    import GridUserSettings from "../../../components/grid/UserSettings";
    import PageTitle from '../../../components/common/PageTitle';
    import { mapGetters } from 'vuex'

    export default {
        components: {
            'grid-user-settings': GridUserSettings,
            PageTitle
        },
        props: {
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                componentName: "eventThemeEditor", // Трабва на конпонентата за бутоните за дашборд настройките
                titleKey: 'eventThemeEditor', // Трабва на конпонентата за бутоните за дашборд настройките
                searchQuery: '',
                defaultGridRows: this.$store.getters.defaultGridRows,
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                customSettingsLoaded: false,
                schemaModelFields: {
                    id: {
                        name: 'id',
                        type: 'number',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.theme.gridHeaders.id'
                    },
                    name: {
                        name: 'name',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.theme.gridHeaders.thematicArea'
                    },
                    nameEn: {
                        name: 'nameEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.theme.gridHeaders.thematicArea'
                    },
                    legalArea: {
                        name: 'legalArea',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.theme.gridHeaders.legalArea'
                    },
                    legalAreaEn: {
                        name: 'legalAreaEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.theme.gridHeaders.legalArea'
                    },
                    active: {
                        name: 'active',
                        type: 'boolean',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.theme.gridHeaders.active'
                    },
                    deactivated: {
                        name: 'deactivated',
                        type: 'boolean',
                        editable: true,
                        nullable: false,
                        visible: false,
                        titleKey: 'registers.theme.gridHeaders.deactivated'
                    },
                },
                childrenSchemaModelFields: {
                    id: {
                        name: 'id',
                        type: 'number',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.id'
                    },
                    thematicAreaId: {
                        name: 'thematicAreaId',
                        type: 'number',
                        editable: false,
                        visible: false,
                        validation: { required: true }
                    },
                    name: {
                        name: 'name',
                        type: 'string',
                        editable: true,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.name',
                        validation: { required: true }
                    },
                    nameEn: {
                        name: 'nameEn',
                        type: 'string',
                        editable: true,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.nameEn'
                    },
                    thematicAreaModel: {
                        defaultValue: { id: 0, text: 'Избери...', textEx: 'Select...' },
                        showHideColumn: false,
                        validation: { required: true }
                    },
                    sort: {
                        name: 'sort',
                        type: 'number',
                        editable: true,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.sort',
                        validation: { required: true, min: 1 }
                    },
                    active: {
                        name: 'active',
                        type: 'boolean',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.active',
                        defaultValue: true
                    },
                    deactivated: {
                        name: 'deactivated',
                        type: 'boolean',
                        editable: true,
                        nullable: false,
                        visible: false,
                        titleKey: 'registers.nomenclatures.gridHeaders.deactivated',
                        validation: { required: false },
                        defaultValue: false
                    },
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/theme/thematicAreaList',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                working: false,
                showUserSettingsForm: false,
                editable: {
                    mode: 'popup',
                    window: {
                        title: "Тема на събитие",
                        animation: true,
                        activate: this.editWindowActivate
                    }
                }
            };
        },
        methods: {
            dataBound(ev) {
                if (!this.customSettingsLoaded) {
                    this.customSettingsLoaded = true;
                    this.loadColumnsVisibilitySettings();
                }

                ev.sender.expandRow(ev.sender.tbody.find('tr.k-master-row').first())
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // Викаме POST action за листване на номенклатурите и трябва да сериализираме
                    // options. Така се предава информация за take, skip , page и списък с обекти
                    // описващи сортирането
                    return kendo.stringify(options);
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                })
            },
            detailInit: function (e) {
                $('<div />').appendTo(e.detailCell).kendoGrid({
                    ref: 'innerGrid',
                    dataSource: {
                        transport: {
                            read: {
                                url: this.$store.getters.baseUrl + '/api/theme/listThemes',
                                dataType: 'json',
                                type: 'POST',
                                contentType: 'application/json',
                                beforeSend: this.beforeSend
                            },
                            create: {
                                url: this.$store.getters.baseUrl + '/api/theme/create',
                                dataType: 'json',
                                type: 'POST',
                                contentType: 'application/json',
                                beforeSend: this.beforeSend
                            },
                            update: {
                                url: this.$store.getters.baseUrl + '/api/theme/update',
                                dataType: 'json',
                                type: 'PUT',
                                contentType: 'application/json',
                                beforeSend: this.beforeSend
                            },
                            parameterMap: this.parameterMap
                        },
                        serverPaging: true,
                        serverSorting: true,
                        serverFiltering: true,
                        filter: { // това филтрира само елементите за дадена родителска категория
                            field: 'thematicAreaId',
                            operator: 'eq',
                            value: e.data.id
                        },
                        schema: {
                            model: {
                                id: 'id',
                                fields: this.childrenSchemaModelFields
                            },
                            total: 'count',
                            data: 'items'
                        },
                        error: this.dataSourceError,
                        requestEnd: this.datasorceRequestEnd
                    },
                    editable: this.claims.eventThemesRegister.update ? this.editable : false,
                    pageable: this.gridOptions.pageable,
                    scrollable: this.gridOptions.scrollable,
                    sortable: this.gridOptions.sortable,
                    filterable: this.gridOptions.filterable,
                    columnMenu: this.gridOptions.columnMenu,
                    groupable: this.gridOptions.groupable,
                    toolbar: this.claims.eventThemesRegister.create ? [{
                        name: 'create',
                        text: this.$t('buttons.create.btnText')
                    }] : [],
                    columns: [{
                        field: 'id',
                        title: this.$t('registers.theme.gridHeaders.id'),
                        width: 100,
                        lockable: true,
                        locked: false,
                        hidden: true,
                    },
                        {
                            field: 'thematicAreaId',
                            title: this.$t('registers.theme.gridHeaders.id'),
                            hidden: true,
                            width: 100,
                            lockable: true,
                            locked: false
                        },
                        {
                            field: 'thematicAreaModel',
                            editor: this.parentIdDropDownEditor,
                            title: this.$t('registers.theme.gridHeaders.thematicArea'),
                            template: this.parentCellTemplate,
                            width: 350,
                            lockable: true,
                            locked: true
                        },
                        {
                            field: 'name',
                            title: this.$t('registers.theme.gridHeaders.name'),
                            width: 450,
                            lockable: true,
                            locked: false
                        },
                        {
                            field: 'nameEn',
                            title: this.$t('registers.theme.gridHeaders.nameEn'),
                            width: 450,
                            lockable: true,
                            locked: false
                        },
                        {
                            field: 'sort',
                            title: this.$t('registers.theme.gridHeaders.sort'),
                            width: 200,
                            lockable: true,
                            locked: false
                        },
                        {
                            field: 'deactivated',
                            title: this.$t('registers.theme.gridHeaders.deactivated'),
                            hidden: true,
                            width: 150,
                            lockable: true,
                            locked: false
                        },
                        {
                            field: 'active',
                            title: this.$t('registers.theme.gridHeaders.active'),
                            template: this.activeCellTemplate,
                            width: 150,
                            lockable: true,
                            locked: false
                        },
                        {
                            width: 200,
                            title: this.$t('actions'),
                            lockable: true,
                            locked: false,
                            visible: this.claims.eventThemesRegister.update,
                            command: [{
                                name: 'edit',
                                text: this.$t('buttons.edit.btnText'),
                                click: this.editClicked
                            }]
                        }]
                })
            },
            activeCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.active ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.active ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            parentCellTemplate: function (dataItem) {
                if (dataItem.thematicAreaModel === null) {
                    return kendo.htmlEncode("");
                }

                let templateHtml = '<span>' + kendo.htmlEncode(this.isEnVersion ? dataItem.thematicAreaModel.textEn : dataItem.thematicAreaModel.text) + '</span>';

                return templateHtml;
            },
            parentIdDropDownEditor: function (container, options) {
                $('<input name="' + options.field + '"/> id="' + options.field + '"')
                    .appendTo(container)
                    .kendoDropDownList({
                        autoBind: false,
                        dataTextField: this.isEnVersion ? 'textEn' : 'text',
                        dataValueField: "id",
                        optionLabel: this.$t('selectThematicArea'),
                        dataSource: {
                            transport: {
                                read: {
                                    url: this.$store.getters.baseUrl + '/api/Dropdown/GetThematicAreas',
                                    dataType: 'json',
                                    type: 'GET',
                                    contentType: 'application/json',
                                    beforeSend: this.beforeSend
                                },
                            },
                            requestEnd: this.dropDownEditorDatasorceRequestEnd(options)
                        }
                    });
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            changeGridSettings() {
                this.showUserSettingsForm = !this.showUserSettingsForm;
            },
            gridSettingsChanged(componentName, name, value) {
                this.setColumnVisibilitySettings();
            },
            loadColumnsVisibilitySettings() {
                return this.$http.get('/api/personalization/' + this.componentName + '/getColumnVisibility'
                ).then((response) => {
                    if (response.data.settings === null) {
                        // Липсват запазени каквито и да е потребителски настройки. Осват тези по подразбиране
                        return;
                    }

                    let settings = [];
                    for (var i = 0; i < response.data.settings.length; i++) {
                        settings.push(response.data.settings[i].name)
                    }

                    for (const key in this.schemaModelFields) {
                        if (this.schemaModelFields.hasOwnProperty(key)
                            && this.schemaModelFields[key].hasOwnProperty('visible')) {
                            this.schemaModelFields[key].visible = settings.includes(key);
                        }
                    }

                    this.setColumnVisibilitySettings();
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            setColumnVisibilitySettings() {
                var grid = this.$refs.grid.kendoWidget();
                var columns = grid.columns;

                // restore columns visibility state using the stored values
                for (var i = 0; i < columns.length; i++) {
                    var column = columns[i];
                    if (!column.field
                        || !this.schemaModelFields.hasOwnProperty(column.field)
                        || !this.schemaModelFields[column.field].hasOwnProperty('visible')) {
                        continue;
                    }

                    if (this.schemaModelFields[column.field].visible) {
                        grid.showColumn(column);
                    } else {
                        grid.hideColumn(column);
                    }
                }
            },
            datasorceRequestEnd(e) {
                if (e.type === "create" && e.response) {
                    e.sender.read()

                    let statusCode = this.$helpers.errorStatusCode(e);
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + statusCode),
                        text: this.$helpers.errorText(e.response),
                        color: statusCode === 200 ? 'success' : 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                } else if (e.type === "update" && e.response) {
                    e.sender.read()

                    let statusCode = this.$helpers.errorStatusCode(e);
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + statusCode),
                        text: this.$helpers.errorText(e.response),
                        color: statusCode === 200 ? 'success' : 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }
            },
            dropDownEditorDatasorceRequestEnd(options) {

            },
            editWindowActivate(e) {

            },
            editClicked(e) {
                console.log('edit', e);
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
        },
        mounted: function () {
        },
        computed: {
            ...mapGetters(['claims', 'gridOptions']),
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            }
        }
    }
</script>

<style scoped>
</style>
